/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Pricing_MonthlyInputs */

const en_landing_pricing_monthly = /** @type {(inputs: Landing_Pricing_MonthlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monthly`)
};

const zh_landing_pricing_monthly = /** @type {(inputs: Landing_Pricing_MonthlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`月付`)
};

/**
* | output |
* | --- |
* | "Monthly" |
*
* @param {Landing_Pricing_MonthlyInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_pricing_monthly = /** @type {((inputs?: Landing_Pricing_MonthlyInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Pricing_MonthlyInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_pricing_monthly(inputs)
	return zh_landing_pricing_monthly(inputs)
});
export { landing_pricing_monthly as "landing.pricing.monthly" }